const getLightness = (hex: string): number => {
  if (hex.length <= 4) {
    const r = hex.charAt(1)
    const g = hex.charAt(2)
    const b = hex.charAt(3)
    hex = `#${r}${r}${g}${g}${b}${b}`
  }

  // Extract red, green, blue values from the hex string
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (!result) return 0 // Fallback if hex is invalid

  const r = parseInt(result[1], 16) / 255
  const g = parseInt(result[2], 16) / 255
  const b = parseInt(result[3], 16) / 255

  // Calculate lightness as the average of the MAX and MIN channel values
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const l = (max + min) / 2

  return l
}

export default getLightness
